import { FC } from 'react'
import {
  BooleanInput, Edit, SimpleForm, TextInput, required,
} from 'react-admin'
import OpenApiUrlField from './OpenApiUrlField'

const ProxyEdit: FC = () => (
  <Edit mutationMode="pessimistic">
    <SimpleForm>
      <TextInput source="display_name" label="data.displayName" fullWidth validate={required()} />
      <TextInput source="description" label="data.description" fullWidth multiline />
      <OpenApiUrlField />
      <BooleanInput source="enabled" label="data.enabled" />
    </SimpleForm>
  </Edit>
)

export default ProxyEdit
